import React from 'react';
import type { AfcSubmission, AfcSubmissionCandidate } from '@axiom/validation';

import { Flashy } from '../../element/Flashy/Flashy';
import { CandidateProposedRateUtil } from '../../../utils/candidate-proposed-rate-util';

export type CandidateSubmissionRateTypes = {
  candidateId: AfcSubmissionCandidate['id'];
  submission: AfcSubmission;
};

export const CandidateSubmissionRate = ({
  candidateId,
  submission,
}: CandidateSubmissionRateTypes) => {
  const rateData = CandidateProposedRateUtil.formatCandidateRate(
    candidateId,
    submission
  );

  if (typeof rateData === 'string') {
    return <span data-test="NO_RATE">{rateData}</span>;
  }

  const { rate, increment, nonDiscountedRate } = rateData;

  if (nonDiscountedRate) {
    return (
      <>
        <Flashy name="OLD_RATE" strikethrough color="textReversedSecondary">
          {nonDiscountedRate}
        </Flashy>{' '}
        <Flashy name="NEW_RATE" bold>
          {rate}/{increment}
        </Flashy>
      </>
    );
  }

  return (
    <span data-test="RATE">
      {rate}/{increment}
    </span>
  );
};
